import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { css } from '@patternfly/react-styles';
import { ToolbarGroup } from './ToolbarGroup';
import { ToolbarItem } from './ToolbarItem';
import { Button } from '../Button';
import { ToolbarContext } from './ToolbarUtils';
export var ToolbarExpandableContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarExpandableContent, _React$Component);

  function ToolbarExpandableContent() {
    _classCallCheck(this, ToolbarExpandableContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ToolbarExpandableContent).apply(this, arguments));
  }

  _createClass(ToolbarExpandableContent, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          expandableContentRef = _a.expandableContentRef,
          chipContainerRef = _a.chipContainerRef,
          isExpanded = _a.isExpanded,
          clearAllFilters = _a.clearAllFilters,
          clearFiltersButtonText = _a.clearFiltersButtonText,
          showClearFiltersButton = _a.showClearFiltersButton,
          props = __rest(_a, ["className", "expandableContentRef", "chipContainerRef", "isExpanded", "clearAllFilters", "clearFiltersButtonText", "showClearFiltersButton"]);

      var numberOfFilters = this.context.numberOfFilters;

      var clearChipGroups = function clearChipGroups() {
        clearAllFilters();
      };

      return React.createElement("div", Object.assign({
        className: css(styles.toolbarExpandableContent, className),
        ref: expandableContentRef
      }, props), React.createElement(ToolbarGroup, null), numberOfFilters > 0 && React.createElement(ToolbarGroup, {
        className: styles.modifiers.chipContainer
      }, React.createElement(ToolbarGroup, {
        ref: chipContainerRef
      }), showClearFiltersButton && React.createElement(ToolbarItem, null, React.createElement(Button, {
        variant: "link",
        onClick: clearChipGroups,
        isInline: true
      }, clearFiltersButtonText))));
    }
  }]);

  return ToolbarExpandableContent;
}(React.Component);
ToolbarExpandableContent.contextType = ToolbarContext;
ToolbarExpandableContent.defaultProps = {
  isExpanded: false,
  clearFiltersButtonText: 'Clear all filters'
};